function AboutToLoseAccountIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 50 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.175.703C.526.703 0 1.23 0 1.88v11.99c0 .649.526 1.175 1.175 1.175h11.99c.65 0 1.176-.526 1.176-1.175V1.879c0-.65-.526-1.176-1.175-1.176H1.176zm6.963 3.093H6.225l.31 6.05h1.28l.323-6.05zm-1.706 8.857c.198.19.448.284.75.284a.98.98 0 00.723-.284.985.985 0 00.298-.724c0-.285-.1-.522-.298-.712a.98.98 0 00-.724-.284c-.301 0-.551.095-.75.284a.943.943 0 00-.297.712c0 .284.1.525.298.724zM19.005.705c-.65 0-1.175.526-1.175 1.175v11.99c0 .65.526 1.176 1.175 1.176h11.99c.65 0 1.176-.526 1.176-1.175V1.88c0-.65-.527-1.176-1.176-1.176h-11.99zm6.963 3.093h-1.914l.31 6.05h1.28l.324-6.05zm-1.707 8.857c.198.19.448.284.75.284a.98.98 0 00.724-.284.985.985 0 00.297-.724c0-.285-.099-.522-.297-.712a.98.98 0 00-.724-.284c-.302 0-.552.095-.75.284a.943.943 0 00-.297.712c0 .284.099.525.297.724zM36.834.705c-.649 0-1.175.526-1.175 1.175v11.99c0 .65.526 1.176 1.175 1.176h11.99c.65 0 1.176-.526 1.176-1.175V1.88c0-.65-.526-1.176-1.175-1.176h-11.99zm6.963 3.093h-1.913l.31 6.05h1.28l.323-6.05zm-1.707 8.857c.199.19.449.284.75.284a.98.98 0 00.724-.284.985.985 0 00.298-.724c0-.285-.1-.522-.298-.712a.98.98 0 00-.724-.284c-.301 0-.551.095-.75.284a.943.943 0 00-.297.712c0 .284.1.525.297.724z"
        fill="#EF4444"
      />
    </svg>
  )
}

export default AboutToLoseAccountIcon
